/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-14 14:48:20
 * @LastEditTime: 2019-08-14 15:01:57
 * @LastEditors: Please set LastEditors
 */
import axios from "axios";
import { Loading } from "element-ui";

let loading: any = null;

const request: any = axios.create({
  baseURL: "/",
  timeout: 0
});

request.interceptors.request.use((config: any) => {
  loading = Loading.service({
    fullscreen: true,
    lock: true,
    text: "加载中..."
  });
  return config;
});

request.interceptors.response.use(
  (resp: any) => {
    loading && loading.close();
    if (resp.status !== 200) {
      return Promise.reject(resp.data);
    }
    return resp.data;
  },
  (error: any) => {
    loading && loading.close();
    return Promise.reject(error);
  }
);

export default request;
